export default __webpack_public_path__ + "static/media/notFoundIcon.07232dd0.svg";